(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["setup-reset-lab"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('setup-reset-lab')) {
    class SetupResetLab extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.addEventListener('change', this.handleChange);
        this.addEventListener('click', this.handleClick);
        this.activate(this.dataset.activeKit || '1', false);
        this.prepareMotion();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.handleChange);
        this.removeEventListener('click', this.handleClick);
        this.observer?.disconnect();
        this.initialized = false;
      }

      prepareMotion() {
        if (!('IntersectionObserver' in window)) {
          this.classList.add('is-visible');
          return;
        }
        this.dataset.motionReady = 'true';
        this.observer = new IntersectionObserver((entries) => {
          if (!entries[0]?.isIntersecting) return;
          this.classList.add('is-visible');
          this.observer.disconnect();
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
        this.observer.observe(this);
      }

      handleChange(event) {
        const trigger = event.target.closest('[data-reset-trigger]');
        if (!trigger || !this.contains(trigger)) return;
        this.activate(trigger.value, true);
      }

      handleClick(event) {
        const button = event.target.closest('[data-reset-add]');
        if (!button || !this.contains(button)) return;
        this.addKit(button);
      }

      activate(index, announce) {
        this.dataset.activeKit = index;
        let activePanel;
        this.querySelectorAll('[data-reset-panel]').forEach((panel) => {
          const active = panel.dataset.resetPanel === index;
          panel.hidden = !active;
          panel.setAttribute('aria-hidden', String(!active));
          panel.inert = !active;
          if (active) activePanel = panel;
        });
        if (announce && activePanel) {
          this.querySelector('[data-reset-status]').textContent = activePanel.dataset.announcement;
        }
      }

      async addKit(button) {
        if (button.disabled) return;
        const label = button.querySelector('[data-reset-button-label]');
        const panel = button.closest('[data-reset-panel]');
        const status = this.querySelector('[data-reset-status]');
        const merchandiseIds = button.dataset.variantIds.split(',').filter((id) => !id.endsWith('/'));
        if (merchandiseIds.length !== 3 || !window.Shopify?.actions?.updateCart) {
          status.textContent = button.dataset.errorMessage;
          return;
        }

        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        label.textContent = button.dataset.addingLabel;

        try {
          const result = await Shopify.actions.updateCart({
            lines: merchandiseIds.map((merchandiseId) => ({ merchandiseId, quantity: 1 })),
          }, {
            event: { context: 'product', detail: { source: 'setup-reset-lab' } },
          });
          if (result.userErrors?.length) throw new Error(result.userErrors[0].message);

          label.textContent = button.dataset.addedLabel;
          panel.classList.add('is-added');
          status.textContent = result.warnings?.[0]?.message || button.dataset.successMessage;
          panel.querySelector('[data-reset-cart-link]').hidden = false;

          if (Number.isFinite(result.cart?.totalQuantity)) {
            document.querySelectorAll('.ss-header__cart > span').forEach((badge) => {
              badge.textContent = result.cart.totalQuantity;
            });
          }

          await Shopify.actions.openCart();
        } catch (error) {
          button.disabled = false;
          label.textContent = button.dataset.errorLabel;
          status.textContent = error?.message || button.dataset.errorMessage;
        } finally {
          button.removeAttribute('aria-busy');
        }
      }
    }

    customElements.define('setup-reset-lab', SetupResetLab);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["setup-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeReviewImages = (scope = document) => {
      scope.querySelectorAll('.ss-reviews').forEach((root) => {
        const hydrateImages = () => {
          root
            .querySelectorAll('img.jdgm-rev__pic-img[data-src]:not([src])')
            .forEach((image) => {
              const source = image.dataset.src;
              const mediaLink = image.closest('.jdgm-rev__pic-link');

              if (!source) return;

              const finishLoading = () => mediaLink?.classList.remove('jdgm--loading');

              image.loading = 'lazy';
              image.decoding = 'async';
              image.addEventListener('load', finishLoading, { once: true });
              image.addEventListener('error', finishLoading, { once: true });
              image.src = source;

              if (image.complete && image.naturalWidth > 0) finishLoading();
            });

          const importedReviewLabel = root.dataset.importedReviewLabel;

          if (importedReviewLabel) {
            const importedReviewBadges = root.querySelectorAll(
              '.jdgm-rev__transparency-badge[data-badge-type="review_collected_from_another_provider"]'
            );

            importedReviewBadges.forEach((badge) => {
              if (!badge.textContent.trim()) badge.textContent = importedReviewLabel;
            });

            if (importedReviewBadges.length > 0) {
              root.querySelector('[data-imported-review-disclosure]')?.removeAttribute('hidden');
            }
          }
        };

        hydrateImages();

        if (root.dataset.ssReviewImagesReady === 'true') return;

        root.dataset.ssReviewImagesReady = 'true';
        new MutationObserver(hydrateImages).observe(root, {
          childList: true,
          subtree: true,
        });
      });
    };

    const start = () => initializeReviewImages();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', (event) => initializeReviewImages(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
